import styled from 'styled-components';

export const TasksSectionWrap = styled.div`
  margin-bottom: 32px;
`;
export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: ${props => props.theme.text.primary};
`;
export const TasksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const TaskCard = styled.div`
  background: ${props => props.theme.card.background};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: ${props => props.theme.card.shadow};
`;
export const TaskIcon = styled.div`
  font-size: 24px;
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.background};
  border-radius: 8px;
`;
export const TaskInfo = styled.div`
  flex: 1;
`;
export const TaskDescription = styled.div`
  font-size: 14px;
  margin-bottom: 4px;
  color: ${props => props.theme.text.primary};
  word-break: break-word;
  white-space: normal;
  overflow-wrap: anywhere;
  max-width: 90vw;
`;
export const TaskReward = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${props => props.theme.text.secondary};
`;
export const TaskButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.primary};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  user-select: none;
  &:hover, &:active, &:focus {
    background: none;
    color: ${props => props.theme.primary};
    box-shadow: none;
    outline: none;
  }
`; 